import { Routes } from '@angular/router';

export const FEEDLOT_ROUTES: Routes = [
	{
		path: 'feedlot',
		loadComponent: () => import('./feature-feedlot/feedlot').then((m) => m.Feedlot),
		data: { title: 'Baias' },
	},
	{
		path: 'feedlot-analysis',
		loadComponent: () =>
			import('./feature-feedlot-analysis/feedlot-analysis').then((m) => m.FeedlotAnalysis),
		data: { title: 'Análise de Baias' },
	},
];
